import { useAtom } from 'jotai';

import useTranslation from '@/utils/hooks/translation/useTranslation';

// Components
import { Select } from '@/components/base/Select/SelectComponent';
// Atoms
import { optionsAtom } from '@/components/pages/giveaway-picker/Atoms/OptionsAtoms';
import { TitleOption } from '@/components/pages/giveaway-picker/OptionsWrapper/components/TitleOption';

export const NumberOfMentions = () => {
    const { t } = useTranslation('giveaway_picker');
    const [options, setOptions] = useAtom(optionsAtom);

    const optionsNumberOfMentions = [
        { label: t('options.no_mentions'), value: null },
        { label: '1', value: 1 },
        { label: '2', value: 2 },
        { label: '3', value: 3 },
        { label: '4', value: 4 },
        { label: '5', value: 5 }
    ];

    const selectedOption =
        optionsNumberOfMentions.find((option) => option.value === options.nb_mentions) ||
        optionsNumberOfMentions[0];

    return (
        <div className="flex flex-col gap-3" data-testid="number-mentions">
            <TitleOption
                title={t('options.number_of_mentions')}
                subtitle={t('options.enter_number_of_mentions')}
            />
            <Select
                className="w-full"
                selected={selectedOption}
                setSelected={(option) =>
                    setOptions((prev) => ({
                        ...prev,
                        nb_mentions: option.value
                    }))
                }
                options={optionsNumberOfMentions}
            />
        </div>
    );
};
